<template>
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body p-0">
      <!--begin::Heading-->
      <div class="card-px text-left py-0 my-10">
        <h2 class="fs-1x fw-bolder mb-10">
          {{ titulo }} de Recinto Penitenciario
        </h2>

        <div class="row">
          <div class="col-md-6">
            <p class="round3">
              Los campos marcados con (<span style="color: red"> * </span>) son
              de llenado obligatorio.
            </p>
          </div>
        </div>

        <div class="row mt-3">
          <input
            type="hidden"
            v-model="state.formData.id_recinto_penitenciario"
          />

          <div class="col-md-6">
            <label class="form-label required">Nombre:</label>
            <input
              type="text"
              class="form-control fuente"
              style="text-transform: uppercase"
              ref="nombre_recinto_penitenciario"
              v-model="state.formData.nombre_recinto_penitenciario"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.nombre_recinto_penitenciario.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Nombre de Recinto Penitenciario requerido</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'minLength'"
                >Debe tener mas de 3 caracteres</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'maxLength'"
                >Debe tener menos de 50 caracteres</span
              >
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label required">Tipo de Centro:</label>
            <select
              class="form-select fuente"
              ref="tipo_recinto_penitenciario"
              aria-label="select"
              v-model="state.formData.tipo_recinto_penitenciario"
            >
              <option value="RÉGIMEN ABIERTO">RÉGIMEN ABIERTO</option>
              <option value="RÉGIMEN INTERMEDIO">RÉGIMEN INTERMEDIO</option>
              <option value="RÉGIMEN CERRADO">RÉGIMEN CERRADO</option>
            </select>
            <span
              class="text-danger"
              v-if="v$.formData.tipo_recinto_penitenciario.$error"
            >
              Tipo de Centro requerido
            </span>
          </div>

          <div class="col-md-6">
            <label class="form-label required">Nivel de Seguridad:</label>
            <select
              class="form-select fuente"
              ref="nivel_seguridad"
              aria-label="select"
              v-model="state.formData.nivel_seguridad"
            >
              <option value="ALTA">ALTA</option>
              <option value="MEDIA">MEDIA</option>
              <option value="MINIMA">MINIMA</option>
            </select>
            <span class="text-danger" v-if="v$.formData.nivel_seguridad.$error">
              Nivel de Seguridad requerido
            </span>
          </div>

          <div class="col-md-6">
            <label class="form-label required">Capacidad:</label>
            <input
              type="number"
              class="form-control fuente"
              ref="capacidad"
              min="0"
              v-model="state.formData.capacidad"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.capacidad.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Capacidad requerida</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'minValue'"
                >Capacidad mínima 10</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'maxValue'"
                >Capacidad máxima 50000</span
              >
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-6">
            <label class="form-label required">Género Poblacional:</label>
            <select
              class="form-select fuente"
              ref="genero_poblacion"
              aria-label="select"
              v-model="state.formData.genero_poblacion"
            >
              <option value="MIXTO PABELLONES SEPARADOS">
                MIXTO PABELLONES SEPARADOS
              </option>
              <option value="FEMENINO">FEMENINO</option>
              <option value="MASCULINO">MASCULINO</option>
            </select>
            <span
              class="text-danger"
              v-if="v$.formData.genero_poblacion.$error"
            >
              Género Poblacional requerido
            </span>
          </div>

          <div class="col-md-6">
            <label class="form-label required">Dirección:</label>
            <input
              type="text"
              class="form-control fuente"
              style="text-transform: uppercase"
              ref="direccion"
              v-model="state.formData.direccion"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.direccion.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Dirección requerida</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'minLength'"
                >Debe tener mas de 3 caracteres</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'maxLength'"
                >Debe tener menos de 50 caracteres</span
              >
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label required">Teléfono:</label>
            <input
              type="number"
              class="form-control fuente"
              ref="telefono"
              min="0"
              v-model="state.formData.telefono"
            />
            <div
              class="input-errors"
              v-for="error of v$.formData.telefono.$errors"
              :key="error.$uid"
            >
              <span class="text-danger" v-if="error.$validator == 'required'"
                >Telefono requerido</span
              >
              <span
                class="text-danger"
                v-else-if="error.$validator == 'minValue'"
                >Digito mínimo 0</span
              >
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-6">
            <label class="form-label required">Departamento:</label>
            <select
              class="form-select fuente"
              ref="departamento"
              aria-label="select"
              v-model="state.formData.departamento"
              @change="listNameProvinces(state.formData.departamento)"
            >
              <option
                :value="departamento.departamento"
                v-for="departamento in departmentsList"
                :key="departamento.departamento"
              >
                {{ departamento.departamento }}
              </option>
            </select>
            <span class="text-danger" v-if="v$.formData.departamento.$error">
              Departamento requerido
            </span>
          </div>

          <div class="col-md-6">
            <label class="form-label required">Provincia:</label>
            <select
              class="form-select fuente"
              ref="provincia"
              aria-label="select"
              v-model="state.formData.provincia"
              :disabled="!state.formData.departamento"
              @change="
                listNameMunicipalities(
                  state.formData.departamento,
                  state.formData.provincia
                )
              "
            >
              <option
                :value="provincia.provincia"
                v-for="provincia in provincesList"
                :key="provincia.provincia"
              >
                {{ provincia.provincia }}
              </option>
            </select>
            <span class="text-danger" v-if="v$.formData.provincia.$error">
              Provincia requerida
            </span>
          </div>

          <div class="col-md-6">
            <label class="form-label required">Municipio:</label>
            <select
              class="form-select fuente"
              ref="municipio"
              aria-label="select"
              :disabled="!state.formData.provincia"
              v-model="state.formData.municipio"
            >
              <option
                :value="municipio.municipio"
                v-for="municipio in municipalitiesList"
                :key="municipio.municipio"
              >
                {{ municipio.municipio }}
              </option>
            </select>
            <span class="text-danger" v-if="v$.formData.municipio.$error">
              Municipio requerido
            </span>
          </div>
        </div>
        <!-- <div class="row mt-3">
          <div class="col-md-10">
            <label class="form-label required">Nueva Sección:</label>
            <input
              type="text"
              class="form-control fuente"
              v-model="nombre_seccion"
            />
          </div>
          <div class="col-md-2 mt-7">
            <button
              type="button"
              style="margin: 5px"
              class="btn btn-primary px-3"
              @click="addFamily()"
            >
              Agregar
            </button>
          </div>
        </div> -->

        <div class="row mt-3">
          <div class="col-md-6">
            <label class="form-label required">Latitud:</label>
            <input
              type="text"
              class="form-control fuente"
              ref="latitud"
              v-model="state.formData.latitud"
            />
            <span class="text-danger" v-if="v$.formData.latitud.$error">
              Latitud requerida
            </span>
          </div>

          <div class="col-md-6">
            <label class="form-label required">Longitud:</label>
            <input
              type="text"
              class="form-control fuente"
              ref="longitud"
              v-model="state.formData.longitud"
            />
            <span class="text-danger" v-if="v$.formData.longitud.$error">
              Longitud requerida
            </span>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-10 offset-md-1">
            <!-- <div class="col-md-12"> -->
            <label class="form-label"
              >Ubique el recinto penitenciario:<br />
              <ul>
                <li>Ingresando el lugar en el buscador del mapa.</li>
                <li>Arrastrando el puntero sobre la ubicación exacta.</li>
              </ul>
            </label>
            <div style="width: 100%; height: 400px">
              <mapbox-map
                :accessToken="myAccessToken"
                :center="[-68.12, -16.5]"
                :zoom="4"
              >
                <mapbox-geocoder-control @result="pushResult" :marker="false" />
                <mapbox-marker
                  :lngLat="[state.formData.longitud, state.formData.latitud]"
                  :draggable="true"
                  @dragend="newPosition"
                >
                </mapbox-marker>
                <mapbox-navigation-control position="bottom-left" />
              </mapbox-map>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-3">
            <label class="form-label required">Servicio Medico:</label>
            <select
              class="form-select fuente"
              ref="servicio_medico"
              aria-label="select"
              v-model="state.formData.servicio_medico"
            >
              <option :value="true">SI</option>
              <option :value="false">NO</option>
            </select>
            <span class="text-danger" v-if="v$.formData.servicio_medico.$error">
              Servicio Medico requerido
            </span>
          </div>
          <div class="col-md-6 mt-3">
            <label class="form-label required">Servicio Legal:</label>
            <select
              class="form-select fuente"
              ref="servicio_legal"
              aria-label="select"
              v-model="state.formData.servicio_legal"
            >
              <option :value="true">SI</option>
              <option :value="false">NO</option>
            </select>
            <span class="text-danger" v-if="v$.formData.servicio_legal.$error">
              Servicio Legal requerido
            </span>
          </div>
          <div class="col-md-6 mt-3">
            <label class="form-label required">Internet:</label>
            <select
              class="form-select fuente"
              ref="internet"
              aria-label="select"
              v-model="state.formData.internet"
            >
              <option :value="true">SI</option>
              <option :value="false">NO</option>
            </select>
            <span class="text-danger" v-if="v$.formData.internet.$error">
              Internet requerido
            </span>
          </div>
          <div class="col-md-6 mt-3">
            <label class="form-label required">Luz:</label>
            <select
              class="form-select fuente"
              ref="luz"
              aria-label="select"
              v-model="state.formData.luz"
            >
              <option :value="true">SI</option>
              <option :value="false">NO</option>
            </select>
            <span class="text-danger" v-if="v$.formData.luz.$error">
              Luz requerido
            </span>
          </div>
          <div class="col-md-6 mt-3">
            <label class="form-label required">Agua:</label>
            <select
              class="form-select fuente"
              ref="agua"
              aria-label="select"
              v-model="state.formData.agua"
            >
              <option :value="true">SI</option>
              <option :value="false">NO</option>
            </select>
            <span class="text-danger" v-if="v$.formData.agua.$error">
              Agua requerido
            </span>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12 text-center">
            <button
              type="button"
              class="btn btn-danger px-4 mx-3"
              @click="back"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="btn btn-primary px-4 mx-3"
              @click="submitButton"
            >
              {{ boton }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
// import vSelect from "vue-select";
// import "vue-select/dist/vue-select.css";
import useVuelidate from "@vuelidate/core";
import {
  required,
  minLength,
  maxLength,
  minValue,
  maxValue,
} from "@vuelidate/validators";

import penitentiary from "@/penitentiary/composables/usePenitentiary";

export default defineComponent({
  name: "readPenitentiary",
  components: {
    // vSelect,
  },
  setup() {
    const router = useRouter();
    const departmentsList = ref([]);
    const provincesList = ref([]);
    const municipalitiesList = ref([]);

    const nombre_recinto_penitenciario = ref(null);
    const tipo_recinto_penitenciario = ref(null);
    const nivel_seguridad = ref(null);
    const capacidad = ref(null);
    const genero_poblacion = ref(null);
    const direccion = ref(null);
    const telefono = ref(null);
    const departamento = ref(null);
    const provincia = ref(null);
    const municipio = ref(null);
    const latitud = ref(null);
    const longitud = ref(null);

    const servicio_medico = ref(null);
    const servicio_legal = ref(null);
    const internet = ref(null);
    const luz = ref(null);
    const agua = ref(null);

    const myAccessToken =
      "pk.eyJ1IjoiYXJpZWwxMTEiLCJhIjoiY2wxNnNrZWFlMTZhejNqcnQwMW03eXV6dCJ9.1PkFvNVxZlVh-b57ntSoNw";
    let titulo = "Registro";
    let boton = "Registrar";
    let edicion = false;

    const state = reactive({
      formData: {
        id_recinto_penitenciario: "",
        nombre_recinto_penitenciario: "",
        tipo_recinto_penitenciario: "",
        nivel_seguridad: "",
        capacidad: "",
        genero_poblacion: "",
        direccion: "",
        telefono: "",
        departamento: "",
        provincia: "",
        municipio: "",
        latitud: "",
        longitud: "",

        servicio_medico: "",
        servicio_legal: "",
        internet: "",
        luz: "",
        agua: "",
      },
    });

    const {
      nameDepartments,
      nameProvinces,
      nameMunicipalities,
      infoPenitentiary,
      createPenitentiary,
      updatePenitentiary,
    } = penitentiary();

    const setPenitentiaryInformation = async () => {
      const { data } = await infoPenitentiary(
        router.currentRoute.value.params.id
      );
      state.formData.id_recinto_penitenciario = data.id_recinto_penitenciario;
      state.formData.nombre_recinto_penitenciario =
        data.nombre_recinto_penitenciario;
      state.formData.tipo_recinto_penitenciario =
        data.tipo_recinto_penitenciario;
      state.formData.nivel_seguridad = data.nivel_seguridad;
      state.formData.capacidad = data.capacidad;
      state.formData.genero_poblacion = data.genero_poblacion;
      state.formData.direccion = data.direccion;
      state.formData.telefono = data.telefono;
      state.formData.departamento = data.departamento;
      state.formData.provincia = data.provincia;
      state.formData.municipio = data.municipio;
      state.formData.latitud = data.latitud;
      state.formData.longitud = data.longitud;

      state.formData.servicio_medico = data.servicio_medico;
      state.formData.servicio_legal = data.servicio_legal;
      state.formData.internet = data.internet;
      state.formData.luz = data.luz;
      state.formData.agua = data.agua;
      listNameProvinces(data.departamento);
      listNameMunicipalities(data.departamento, data.provincia);
    };

    // EVALUACIÓN REGISTRO/EDICIÓN
    if (router.currentRoute.value.params.id != "0") {
      titulo = "Edición";
      boton = "Actualizar";
      edicion = true;
      setPenitentiaryInformation();
    }

    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
    });

    // REGISTRO DE LATITUD LONGITUD EN BASE A BUCADOR DE MAP BOX
    const pushResult = (data) => {
      // console.log(data, data.center, 'Longitud', data.center[0], 'Latitud', data.center[1])
      state.formData.longitud = data.center[0].toFixed(8);
      state.formData.latitud = data.center[1].toFixed(8);
    };

    // ACTUALIZACIÓN DE LATITUD LONGITUD EN BASE A ARRASTRE DEL PUNTERO MAP BOX
    const newPosition = (data) => {
      state.formData.longitud = data.target._lngLat.lng.toFixed(8);
      state.formData.latitud = data.target._lngLat.lat.toFixed(8);
    };

    // SELECT DEPARTAMENTOS
    const listNameDepartments = async () => {
      const { data } = await nameDepartments();
      departmentsList.value = data;
      // console.log(departmentsList.value)
    };

    // SELECT PROVINCIAS
    const listNameProvinces = async (nameDepartment) => {
      // console.log('listNameProvinces', nameDepartment)
      // state.formData.municipio = ''
      // delete state.formData.municipio

      const { data } = await nameProvinces(nameDepartment);
      provincesList.value = data;
    };

    // SELECT MUNICIPIOS
    const listNameMunicipalities = async (nameDepartment, nameProvince) => {
      // console.log('captura', nameDepartment, nameProvince)
      const { data } = await nameMunicipalities(nameDepartment, nameProvince);
      // console.log(data)
      municipalitiesList.value = data;
    };

    // VALIDACIONES
    const rules = computed(() => {
      return {
        formData: {
          nombre_recinto_penitenciario: {
            required,
            minLength: minLength(4),
            maxLength: maxLength(50),
          },
          tipo_recinto_penitenciario: { required },
          nivel_seguridad: { required },
          capacidad: {
            required,
            minValue: minValue(10),
            maxValue: maxValue(50000),
          },
          genero_poblacion: { required },
          direccion: {
            required,
            minLength: minLength(4),
            maxLength: maxLength(50),
          },
          telefono: { required, minValue: minValue(0) },
          departamento: { required },
          provincia: { required },
          municipio: { required },
          latitud: { required },
          longitud: { required },

          servicio_medico: { required },
          servicio_legal: { required },
          internet: { required },
          luz: { required },
          agua: { required },
        },
      };
    });
    const v$ = useVuelidate(rules, state);

    // BOTON CANCELAR
    const back = () => {
      router.push({ name: "listPenitentiary" });
    };

    // BOTON REGISTRAR
    const submitButton = async () => {
      // console.log('formulario', state.formData)
      v$.value.$validate();
      if (!v$.value.$error) {
        let data;
        // console.log(state.formData)
        // PARSEO DE VARIABLES DEL FORMULARIO
        state.formData.nombre_recinto_penitenciario =
          state.formData.nombre_recinto_penitenciario
            .replace(/['`"]+/g, "")
            .toUpperCase();
        state.formData.direccion = state.formData.direccion
          .replace(/['`"]+/g, "")
          .toUpperCase();

        // REDIRECCIONAMIENTO
        if (router.currentRoute.value.params.id != "0") {
          // console.log('enviar a update', state.formData)
          data = await updatePenitentiary(state.formData);
        } else {
          // console.log('enviar a create', state.formData)
          data = await createPenitentiary(state.formData);
        }

        // ALERTAS
        if (data.data) {
          Toast.fire({
            icon: "success",
            title: data.data.message,
          });
          router.push({ name: "listPenitentiary" });
        } else {
          Toast.fire({
            icon: "error",
            title: data.message.response.data,
          });
        }
      } else {
        const expr = v$.value.$errors[0].$property;
        // let { nombre_recinto_penitenciario: expr } = nombre_recinto_penitenciario
        // expr = ref(null)
        // console.log(expr)

        switch (expr) {
          case "nombre_recinto_penitenciario":
            nombre_recinto_penitenciario.value.focus();
            break;
          case "tipo_recinto_penitenciario":
            tipo_recinto_penitenciario.value.focus();
            break;
          case "nivel_seguridad":
            nivel_seguridad.value.focus();
            break;
          case "capacidad":
            capacidad.value.focus();
            break;
          case "genero_poblacion":
            genero_poblacion.value.focus();
            break;
          case "direccion":
            direccion.value.focus();
            break;
          case "telefono":
            telefono.value.focus();
            break;
          case "departamento":
            departamento.value.focus();
            break;
          case "provincia":
            provincia.value.focus();
            break;
          case "municipio":
            municipio.value.focus();
            break;
          case "latitud":
            latitud.value.focus();
            break;
          case "longitud":
            longitud.value.focus();
            break;

          case "servicio_medico":
            servicio_medico.value.focus();
            break;
          case "servicio_legal":
            servicio_legal.value.focus();
            break;
          case "internet":
            internet.value.focus();
            break;
          case "luz":
            luz.value.focus();
            break;
          case "agua":
            agua.value.focus();
            break;
        }
      }
    };

    onMounted(() => {
      listNameDepartments();
      // nombre_recinto_penitenciario.value.focus();
    });

    return {
      listNameDepartments,
      listNameProvinces,
      listNameMunicipalities,
      back,
      submitButton,
      // createPenitentiary,
      // updatePenitentiary,
      departmentsList,
      provincesList,
      municipalitiesList,
      // nameProvince,
      state,
      v$,
      myAccessToken,
      newPosition,
      pushResult,

      titulo,
      boton,

      setPenitentiaryInformation,

      nombre_recinto_penitenciario,
      tipo_recinto_penitenciario,
      nivel_seguridad,
      capacidad,
      genero_poblacion,
      direccion,
      telefono,
      departamento,
      provincia,
      municipio,
      latitud,
      longitud,

      servicio_medico,
      servicio_legal,
      internet,
      luz,
      agua,
    };
  },
});
</script>

<style>
.fuente {
  font-size: 0.97em;
  padding: 0.35em;
  font-weight: normal;
}
</style>
